// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import GetItemJsonRequest from '../contract/GetItemJsonRequest';

export default function getItemJsonRequest(data: GetItemJsonRequest): GetItemJsonRequest {
    let result: GetItemJsonRequest = {
        __type: 'GetItemJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
